// extracted by mini-css-extract-plugin
export var border = "Monogram-module--border--9c707";
export var footer = "Monogram-module--footer--dfbd4";
export var path = "Monogram-module--path--323c3";